import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, MessageSquare } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigation = [
    { name: 'Start', href: '/' },
    { name: 'Leistungen', href: '/leistungen' },
    { name: 'Preise', href: '/preise' },
    { name: 'Einsatzgebiet', href: '/einsatzgebiet-dortmund' },
    { name: 'Über uns', href: '/ueber-uns' },
    { name: 'Blog', href: '/blog' },
    { name: 'Kontakt', href: '/kontakt' }
  ];

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="text-2xl font-bold text-[#0F172A]">
              Schössow <span className="text-[#16A34A]">Dienstleistungen</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex lg:items-center lg:gap-x-6">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-sm font-medium text-gray-700 hover:text-[#16A34A] transition-colors"
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Desktop CTAs */}
          <div className="hidden lg:flex lg:items-center lg:gap-x-3">
            <Button
              asChild
              variant="outline"
              className="border-[#16A34A] text-[#16A34A] hover:bg-[#16A34A] hover:text-white"
            >
              <a href="tel:+4923139085116" className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                Jetzt anrufen
              </a>
            </Button>
            <Button
              asChild
              className="bg-[#16A34A] hover:bg-[#16A34A]/90 text-white"
            >
              <Link to="/kontakt" className="flex items-center gap-2">
                Angebot in 60 Sek.
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="icon"
              className="border-[#16A34A] text-[#16A34A] hover:bg-[#16A34A] hover:text-white"
            >
              <a href="https://wa.me/4923139085116" target="_blank" rel="noopener noreferrer">
                <MessageSquare className="h-4 w-4" />
              </a>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            type="button"
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-gray-900" />
            ) : (
              <Menu className="h-6 w-6 text-gray-900" />
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-base font-medium text-gray-700 hover:text-[#16A34A]"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;